import { useMemo } from "react";
import { useAuthContext } from "@/providers/auth-provider";
import {
  DEFAULT_ALLOWED_ARNS,
  distributorArnFromUsername,
  RESEARCH_ARNS,
} from "creso-core/utils";
import { isNonProduction } from "web-core/utils";

export interface UnstableFeatures {
  basketRebalance: boolean;
  giftHdfcAmc: boolean;
  customBranding: boolean;
  portfolioReview: boolean;
}

export function useUnstableFeatures(): UnstableFeatures {
  const { user } = useAuthContext();

  const arn = distributorArnFromUsername(user?.username ?? "");

  const isCresoAdmin = DEFAULT_ALLOWED_ARNS.includes(arn);

  const isResearchArn = RESEARCH_ARNS.includes(arn);

  return useMemo(
    () => ({
      basketRebalance: true,
      giftHdfcAmc: true,
      customBranding: true,
      portfolioReview: isCresoAdmin || isResearchArn || isNonProduction(),
    }),
    [isResearchArn, isCresoAdmin]
  );
}
